(() => {
  if (customElements.get('animate-symbols')) {
    return;
  }

  class AnimateSymbols extends HTMLElement {
    constructor() {
      super();
      this.symbols = this.querySelectorAll('[data-symbol]');
    }

    connectedCallback() {
      this.start();

      setInterval(() => {
        this.start();
      }, 9000);
    }

    start() {
      this.symbols.forEach(el => {
        const symbol = el.dataset.entry;
        var specialSymbols = "!?%*.";

        const randomArr =  this.getRandomSymbols(5);
        let myTimeout = null;
        const interval = Math.floor(Math.random() * (1000 - 500 + 1) + 500);

        for (let i = 0; i <= randomArr.length; i++) {
          myTimeout = setTimeout(() => {
            if(parseInt(symbol) || symbol == '0') {
              el.innerHTML = Math.floor(Math.random() * (9 - 0 + 1) + 0);
            } else if (symbol.toUpperCase() != symbol.toLowerCase() || symbol.codePointAt(0) > 127) {
              el.innerHTML = randomArr[i];
            } else {
              el.innerHTML = specialSymbols.charAt(Math.floor(Math.random() * specialSymbols.length));
            }

            if(i == randomArr.length - 1) {
              el.innerHTML = symbol;
            }
          }, i * interval)
        }

        clearTimeout(myTimeout);
      })
    }

    getRandomSymbols(count) {
      let symbols = [];
      for (let i = 0; i < count; i++) {
        const random = (Math.random() + 1).toString(36).substring(7).slice(1,2);
        symbols.push(random)
      }
      return symbols;
    }
  }

  customElements.define('animate-symbols', AnimateSymbols);
})();
